const VPEvents = {
  VP_DATA_CHANGED: 'VP/data_changed',
  VP_BLOCK_ERROR: 'VP/block_error',
};
export default VPEvents;
